module.exports = __webpack_public_path__ + "img/prayer_times.89c2efae.jpg";